import * as React from "react";
import styled from "styled-components/native";

import { LayoutRow, Paragraph, Title } from "../../styled-component";

const ErrorMessageContainer = styled.View``;

export interface ErrorMessageProps {}

function ErrorMessage({}: ErrorMessageProps) {
  return (
    <ErrorMessageContainer>
      <Title>Error</Title>
      <Paragraph>An error has ocurred.</Paragraph>
    </ErrorMessageContainer>
  );
}

export default ErrorMessage;
